import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: "grid",
    gridTemplateAreas: `
			'video video deviceSelection'
			'backgroundMenu backgroundMenu backgroundMenu'
		`,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    maxWidth: 1050,
    gridGap: theme.spacing(4),
    gridTemplateColumns: "1fr 1fr 1fr",
    [theme.breakpoints.down("lg")]: {
      gridGap: theme.spacing(2),
      gridTemplateAreas: `
			'video'
      'deviceSelection'
			'backgroundMenu'
		`,
      gridTemplateColumns: "1fr",
    },
  },
  video: {
    gridArea: "video",
    maxWidth: 700,
  },
  backgroundMenu: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    gridArea: "backgroundMenu",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    [theme.breakpoints.down("lg")]: {
      justifyContent: "center",
    },
  },
  button: {
    background: theme.palette.white,
    color: theme.palette.black,
    borderRadius: 5,
    border: `1px solid ${theme.palette.gray.light}`,
    gridColumnEnd: "span 3",
    objectFit: "contain",
    overflow: "hidden",
    position: "relative",
    width: 145,
    height: 108,
    transition: "all 200ms",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      borderColor: theme.palette.events.bluePrimary,
      boxShadow: `inset 0 0 0 1px ${theme.palette.events.bluePrimary}`,
    },
    padding: 0,
  },
  buttonContent: {
    flexDirection: "column",
    gap: theme.spacing(1),
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    padding: 0,
    fontSize: 12,
  },
  backgroundImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
    position: "absolute",
    padding: 2,
    top: 0,
    left: 0,
    boxSizing: "border-box",
    overflow: "hidden",
  },
}));
